module.exports = __webpack_public_path__ + "img/5-2.835fb565.png";